import { AppBar, Box, Drawer, Grid, IconButton, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Toolbar, Typography } from '@mui/material'
import React, { useState } from 'react'
import MenuIcon from '@mui/icons-material/Menu';
import WorkOutlineOutlinedIcon from '@mui/icons-material/WorkOutlineOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import MonetizationOnOutlinedIcon from '@mui/icons-material/MonetizationOnOutlined';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import StorageIcon from '@mui/icons-material/Storage';
import { Link, NavLink, useNavigate, useParams } from 'react-router-dom';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import { useTheme } from '@emotion/react';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import useSignout from '../hooks/use-signout';
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import RequestPageOutlinedIcon from '@mui/icons-material/RequestPageOutlined';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { APP_CURRENCY, BRAND_NAME, ROLE } from '../constants';
import useAuth from '../hooks/use-auth';

const Navbar = () => {
    const theme = useTheme();
    const { user, protector } = useAuth()
    const [isDrawerOpen, setIsDrawerOpen] = useState(false)
    // const current_theme = useSelector(state => state.ui.isDarkMode)
    const navigate = useNavigate()
    const params = useParams()

    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const navigateProfile = () => {
        navigate('/accounts/profile')
        setAnchorEl(null);
    }

    const navigateSubscription = () => {
        navigate('/wallet')
        setAnchorEl(null);
    }
    const handleClose = () => {
        setAnchorEl(null);
    };
    const signout = useSignout()
    return (
        <>
            <AppBar position="static" color="primary" sx={{ boxShadow: "none" }} enableColorOnDark>
                <Toolbar>
                    <IconButton edge="start" color="inherit" aria-label="menu" sx={{ mr: 2, display: { lg: "none" } }} onClick={() => setIsDrawerOpen(true)} >
                        <MenuIcon />
                    </IconButton>
                    <Box sx={{ display: "flex", alignItems: "center", flexGrow: 1, }}>
                        <Box sx={{ pt: 1, display: "flex", alignItems: "center", cursor: "pointer" }} onClick={() => { navigate('/') }}>
                            <img style={{ maxWidth: "40px" }} src={process.env.PUBLIC_URL + "/assets/logo.png"} alt="Primeophoto logo" />
                            <Typography sx={{ marginLeft: "10px", fontSize: "20px" }} variant="span" fontWeight={400}>{BRAND_NAME}</Typography>
                        </Box>
                    </Box>
                    <Box>
                        <Box
                            size="large"
                            aria-label="account of current user"
                            aria-controls="menu-appbar"
                            aria-haspopup="true"
                            onClick={handleMenu}
                            color="inherit"
                        >
                            <Box sx={{ display: "flex", cursor: "pointer", alignItems: "center", gap: 1 }}>
                                <Box sx={{ textAlign: "end" }}>
                                    <Typography sx={{ display: { xs: "none", sm: "block" }, fontWeight: 500 }}>{user != null ? user.first_name : ""}</Typography>
                                    {protector([ROLE.client]) &&
                                        <Typography sx={{ display: { xs: "none", sm: "inline" }, borderRadius: 1, fontWeight: 500, fontSize: 14, }}>
                                            Credits: {user.wallet && `${APP_CURRENCY.currency_symbol} ${user.wallet.wallet_amount}`}
                                        </Typography>
                                    }
                                </Box>
                                {user && user.headshot != null ?
                                    <img src={user.headshot.url} alt='' style={{ width: "40px", height: "40px", borderRadius: "50%", objectFit: "cover", objectPosition: "top" }} />
                                    :
                                    <AccountCircleOutlinedIcon />
                                }
                            </Box>
                        </Box>
                        <Menu
                            id="menu-appbar"
                            anchorEl={anchorEl}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            open={Boolean(anchorEl)}
                            onClose={handleClose}
                        >
                            {protector([ROLE.client]) &&
                                <MenuItem onClick={navigateSubscription}>
                                    <Typography sx={{ fontWeight: "500", borderBottom: "1px solid #e6e6e6" }}>
                                        {user.wallet && `${APP_CURRENCY.currency_symbol} ${user.wallet.wallet_amount}`}
                                    </Typography>

                                </MenuItem>
                            }
                            <MenuItem onClick={navigateProfile}>My Profile</MenuItem>
                            <MenuItem onClick={signout}>Sign out</MenuItem>
                        </Menu>
                    </Box>
                </Toolbar>
            </AppBar>
            <Drawer
                anchor={'left'}
                open={isDrawerOpen}
                onClose={() => setIsDrawerOpen(false)}
            >
                <Box
                    sx={{ width: '250px', pr: 1, }}
                    className={"sidebar_active nav_drawer"}
                    role="presentation"
                    onClick={() => setIsDrawerOpen(false)}
                    onKeyDown={() => setIsDrawerOpen(false)}
                >
                    <Box sx={{ display: "flex", justifyContent: "space-between", flexDirection: "column", height: "calc(100vh - 64px)", overflowY: "auto" }}>
                        {!(params.id === 'create' || params.draftId)
                            ? <Box>
                                <List>
                                    <NavLink to={'/'} style={{ color: theme.palette.text.primary }}>
                                        <ListItem disablePadding>
                                            <ListItemButton>
                                                <ListItemIcon>
                                                    <DashboardOutlinedIcon />
                                                </ListItemIcon>
                                                <ListItemText primary="Dashboard" />
                                            </ListItemButton>
                                        </ListItem>
                                    </NavLink>
                                </List>
                                <List>
                                    <NavLink to={'/jobs'} style={{ color: theme.palette.text.primary }}>
                                        <ListItem disablePadding>
                                            <ListItemButton>
                                                <ListItemIcon>
                                                    <WorkOutlineOutlinedIcon />
                                                </ListItemIcon>
                                                <ListItemText primary="Jobs" />
                                            </ListItemButton>
                                        </ListItem>
                                    </NavLink>
                                </List>
                                {
                                    protector([
                                        ROLE.sa,
                                        ROLE.admin,
                                        ROLE.client,
                                    ]) && <List>
                                        <NavLink to={'/invoices'} style={{ color: theme.palette.text.primary }}>
                                            <ListItem disablePadding>
                                                <ListItemButton>
                                                    <ListItemIcon>
                                                        <DescriptionOutlinedIcon />
                                                    </ListItemIcon>
                                                    <ListItemText primary="Invoice" />
                                                </ListItemButton>
                                            </ListItem>
                                        </NavLink>
                                    </List>}
                                {
                                    protector([
                                        ROLE.client,
                                    ]) && <List>
                                        <NavLink to={'/wallet'} style={{ color: theme.palette.text.primary }}>
                                            <ListItem disablePadding>
                                                <ListItemButton>
                                                    <ListItemIcon>
                                                        <MonetizationOnOutlinedIcon />
                                                    </ListItemIcon>
                                                    <ListItemText primary="Wallet" />
                                                </ListItemButton>
                                            </ListItem>
                                        </NavLink>
                                    </List>
                                }
                                {
                                    protector([
                                        ROLE.client,
                                    ]) && <List>
                                        <NavLink to={'/transaction'} style={{ color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}>
                                            <ListItem disablePadding>
                                                <ListItemButton>
                                                    <ListItemIcon>
                                                        <RequestPageOutlinedIcon />
                                                    </ListItemIcon>
                                                    <ListItemText primary="Transaction" />
                                                </ListItemButton>
                                            </ListItem>
                                        </NavLink>
                                    </List>}
                                {
                                    protector([
                                        ROLE.sa,
                                        ROLE.admin,
                                    ]) && <List>
                                        <NavLink to={'/user'} style={{ color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}>
                                            <ListItem disablePadding>
                                                <ListItemButton>
                                                    <ListItemIcon>
                                                        <PersonOutlineIcon />
                                                    </ListItemIcon>
                                                    <ListItemText primary="Users" />
                                                </ListItemButton>
                                            </ListItem>
                                        </NavLink>
                                    </List>}
                                {/* <List>
                            <NavLink to={'/services'} style={{ color: theme.palette.text.primary }}>
                                <ListItem disablePadding>
                                    <ListItemButton>
                                        <ListItemIcon>
                                            <WorkIcon />
                                        </ListItemIcon>
                                        <ListItemText primary="Services" />
                                    </ListItemButton>
                                </ListItem>
                            </NavLink>
                        </List> */}
                                {
                                    protector([
                                        ROLE.client,
                                    ]) && <List>
                                        <NavLink to={'/photosettings'} style={{ color: theme.palette.text.primary }}>
                                            <ListItem disablePadding>
                                                <ListItemButton>
                                                    <ListItemIcon>
                                                        <ImageOutlinedIcon />
                                                    </ListItemIcon>
                                                    <ListItemText primary="Photo settings" />
                                                </ListItemButton>
                                            </ListItem>
                                        </NavLink>
                                    </List>}
                                {
                                    protector([
                                        ROLE.client,
                                    ]) && <List>
                                        <NavLink to={'/storage'} style={{ color: theme.palette.text.primary }}>
                                            <ListItem disablePadding>
                                                <ListItemButton>
                                                    <ListItemIcon>
                                                        <StorageIcon />
                                                    </ListItemIcon>
                                                    <ListItemText primary="Storage" />
                                                </ListItemButton>
                                            </ListItem>
                                        </NavLink>
                                    </List>}
                                {
                                    protector([
                                        ROLE.sa,
                                        ROLE.admin,
                                    ]) && <List>
                                        <NavLink to={'/admin'} style={{ color: theme.palette.text.primary }}>
                                            <ListItem disablePadding>
                                                <ListItemButton>
                                                    <ListItemIcon>
                                                        <ManageAccountsOutlinedIcon />
                                                    </ListItemIcon>
                                                    <ListItemText primary="Admin Settings" />
                                                </ListItemButton>
                                            </ListItem>
                                        </NavLink>
                                    </List>}
                                {/* <Divider /> */}
                                <List>
                                    <NavLink to={'/accounts/profile'} style={{ color: theme.palette.text.primary }}>
                                        <ListItem disablePadding>
                                            <ListItemButton>
                                                <ListItemIcon>
                                                    <AccountCircleOutlinedIcon />
                                                </ListItemIcon>
                                                <ListItemText primary="Profile" />
                                            </ListItemButton>
                                        </ListItem>
                                    </NavLink>
                                </List>
                                {protector([ROLE.editor, ROLE.qc]) &&
                                    <List>
                                        <NavLink to={'/report'} style={{ color: theme.palette.text.primary }}>
                                            <ListItem disablePadding>
                                                <ListItemButton>
                                                    <ListItemIcon>
                                                        <AccountCircleOutlinedIcon />
                                                    </ListItemIcon>
                                                    <ListItemText primary="Report" />
                                                </ListItemButton>
                                            </ListItem>
                                        </NavLink>
                                    </List>
                                }
                                {/* <Divider /> */}
                                {/* <List>
                            <ListItem disablePadding>
                                <ListItemButton
                                    onClick={(e) => {
                                        e.stopPropagation()
                                        dispatch(uiActions.setDarkMode(!current_theme))
                                    }}
                                >
                                    <ListItemIcon>
                                        {current_theme ? <DarkModeOutlinedIcon /> : <LightModeOutlinedIcon />}
                                    </ListItemIcon>
                                    <ListItemText primary="Theme" />
                                </ListItemButton>
                            </ListItem>
                        </List> */}
                            </Box>
                            :
                            <Box>
                                <List>
                                    <NavLink to={'/'} style={{ color: theme.palette.text.primary }}>
                                        <ListItem disablePadding>
                                            <ListItemButton>
                                                <ListItemIcon>
                                                    <ArrowBackIcon />
                                                </ListItemIcon>
                                                <ListItemText primary="Back to Jobs page" />
                                            </ListItemButton>
                                        </ListItem>
                                    </NavLink>
                                </List>
                            </Box>
                        }

                    </Box>
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", p: 2 }}>
                        <Typography sx={{ fontSize: "14px", color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}>App Version</Typography>
                        <Typography sx={{ fontSize: "14px", color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}>V{process.env.REACT_APP_VERSION}</Typography>
                    </Box>
                </Box>
            </Drawer>
        </>
    )
}

export default Navbar